import TransactionsDashboardContainer from './TransactionsDashboardContainer';

export default TransactionsDashboardContainer;
